import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

const EmptyInsurancePolicyProductsComponent = () => {
  return (
    <div
      data-testid="insurance-policy-products-list-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center gap-1`}
    >
      <Typography variant="subtitle1">No products in this policy</Typography>
      <Typography variant="body2" css={tw`text-shades-500`}>
        Add one to set its pricing, contract and coverage.
      </Typography>
    </div>
  )
}

export const EmptyInsurancePolicyProducts = memo(EmptyInsurancePolicyProductsComponent)
